<template>
    <div>
        <div class="is-relative" style="min-height: 480px">
            <b-loading :active="isLoading" :is-full-page="false" />
            <div style="min-height: 44px">
                <b-field label="Должность" :class="{invalid: hasError('positions')}" :type="type('positions')" :message="error('positions', 'Укажите должность билета')">
                    <multiselect :multiple="true" :allow-empty="false" v-model="selectedPosition" :disabled="!editable" :options="positions" @input="onFormChange" label="name" trackBy="id" placeholder="Должность" >
                        <template #noResult="props">
                            Не найдено ничего
                        </template>
                        <template #noOptions="props">
                            Пусто
                        </template>
                    </multiselect>
                </b-field>
            </div>
            <hr />
            <div class="columns" >
                <div class="column" >
                    <b-field label="Название" :type="type('title')" :message="errorOrMessage('title', 'Укажите название билета')">
                        <b-input @input="onFormChange" @blur="touch('title')" v-model="form.title" :disabled="!editable" type="text" placeholder="Проверка знаний поездного диспетчера"></b-input>
                    </b-field>
                    <b-field label="Описание" :type="type('description')" :message="errorOrMessage('description', 'Укажите описание билета')">
                        <b-input @input="onFormChange" @blur="touch('description')" v-model="form.description" :disabled="!editable"  rows="8" type="textarea" placeholder="Проверка знаний поездного диспетчера"></b-input>
                    </b-field>
                </div>
                <div class="column">
                    <b-field label="Дата начала" >
                        <b-datepicker
                            @input="onFormChange"
                            expanded
                            :disabled="!editable"
                            placeholder="01.03.2021"
                            :max-date="endDate"
                            v-model="startDate"
                            icon="calendar-today"
                        >
                        </b-datepicker>
                    </b-field>
                    <b-field label="Дата окончания">
                        <b-datepicker
                            @input="onFormChange"
                            expanded
                            :disabled="!editable"
                            placeholder="03.08.2021"
                            :min-date="startDate"
                            v-model="endDate"
                            icon="calendar-today"
                        >
                        </b-datepicker>
                    </b-field>

                    <b-field label="Количество вопросов"  :type="type('questionCount')" :message="errorOrMessage('questionCount', questionCountErrorMessage, questionCountErrorMessage)">
                        <b-numberinput @input="onFormChange('questionCount')" @blur="touch('questionCount')" required step="1" v-model="questionCount" :disabled="!editable" placeholder="10" :min="$v.form.questionCount.$params.between.min" :max="$v.form.questionCount.$params.between.max" />
                    </b-field>
                    <b-field label="Лимит времени (минуты)" :type="type('timeLimit')" :message="errorOrMessage('timeLimit', timeLimitErrorMessage, timeLimitErrorMessage)">
                        <b-numberinput @input="onFormChange('timeLimit')" @blur="touch('timeLimit')" required step="1" v-model="timeLimit" :disabled="!editable" placeholder="10" :min="$v.form.timeLimit.$params.between.min" :max="$v.form.timeLimit.$params.between.max / 60" />
                    </b-field>
                </div>
            </div>
        </div>
        <hr />
        <b-field label="Директории" :type="type('folders')" :message="error('folders', 'Укажите директории')"></b-field>
        <div style="overflow-x: auto;">
            <div v-if="folders.length">
                <tree
                    ref="tree"
                    class="tree--small"
                    :data="folders"
                    :options="treeOptions"
                    @node:checked="checked"
                    @node:unchecked="unchecked"
                    @tree:mounted="treeMounted"
                >
                    <div style="display: flex;align-items: center;" slot-scope="{ node }">
                        <i v-if="!editable" class="tree-checkbox-disabled" :class="{'checked': node.states.checked, 'indeterminate': node.states.indeterminate}" />
                        <span>[{{ node.data.count }}] {{ node.text }}</span>
                    </div>
                </tree>
            </div>
            <div v-else class="is-relative" style="min-height: 50px">
                <b-loading v-if="isTreeLoading" :active="isTreeLoading" :is-full-page="false" />
                <div v-else>Нет директорий. Попробуйте выбрать другую должность.</div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'

import { mapActions, mapGetters } from 'vuex'

import { get, map, filter, includes, values, ceil, each, uniq, reduce, uniqBy, clone, round } from 'lodash'

import LiquorTree from 'liquor-tree'
import HasErrors from '../../../../mixins/HasErrors'
Vue.use(LiquorTree)
import { DateTime } from "luxon"
let toDay = DateTime.now()
import { required, between, integer, decimal } from 'vuelidate/lib/validators'

export default
{
    props: {
        educationPlanId: {
            default: null,
            type: [String, null]
        },
        editable: {
            default: false,
            type: Boolean,
        },
    },
    mixins: [HasErrors],
    validations: {
        form: {
            positions: {
                required,
            },
            title: {
                required,
            },
            description: {

            },
            timeLimit: {
                required,
                integer,
                decimal,
                between: between(0, 180 * 60)
            },
            questionCount: {
                required,
                integer,
                decimal,
                between: between(1, 100)
            },
            folders: {
                required,
            },
        }

    },
    data() {
        return {
            folders: [],
            treeOptions: {
                checkbox: this.editable,
                propertyNames: {
                    text: 'text',
                    children: 'children'
                }
            },
            saveButtonIsDisabled: true,
            saving: false,
            checkedIds: {},
            selectedPosition: [],
            cachedKnowledgevolumePositionIds: [],
            cachedKnowledgevolumeIds: [],
            isPositionsCached: false,

            startDate: toDay.toJSDate(),
            endDate: toDay.plus({ month: 1 }).toJSDate(),

            form: {
                id: null,
                organizationId: null,
                folders: [],
                positions: [],
                startDate: '',
                endDate: '',
                title: null,
                description: null,
                timeLimit: 3000,
                questionCount: 50,
            }
        }
    },
    computed: {
        ...mapGetters({
            positionFind: 'e/positions/find',
            positionList: 'e/positions/all',
            questionHierarchyQuery: 'e/questionHierarchy/query',
            isLoaderActive: 'e/pages/isLoaderActive',
            educationPlansList: 'e/educationPlans/all',
            educationPlansFind: 'e/educationPlans/find',
            educationPlansQuery: 'e/educationPlans/query',
            knowledgesQuery: 'e/knowledges/query',
            currentOrganizationId: 'e/users/currentOrganizationId',
        }),
        timeLimit: {
            get() {
                return this.form.timeLimit ? ceil(this.form.timeLimit / 60) : 0
            },
            set (val) {
                this.form.timeLimit = val ? ceil(val) * 60 : 0
            }
        },
        questionCount: {
            get() {
                return this.form.questionCount ? ceil(this.form.questionCount) : 0
            },
            set (val) {
                this.form.questionCount = ceil(val)
            }
        },
        questionCountErrorMessage() {
            return `минимум - ${this.$v.form.questionCount.$params.between.min} вопрос, максимум ${this.$v.form.questionCount.$params.between.max} вопросов.`
            + (this.$v.form.questionCount.integer === false ? ' Число не может быть дробным' :'' )
        },
        timeLimitErrorMessage() {
            return `${this.$v.form.timeLimit.$params.between.min} - нет ограничений, максимум ${this.$v.form.timeLimit.$params.between.max / 60} минут`
            + (this.$v.form.timeLimit.integer === false ? ' Число не может быть дробным' :'' )
        },
        id () {
            return this.educationPlanId
        },
        positions() {
            return this.positionList()
        },
        educationPlan() {
            return this.educationPlansQuery().with('positions').find(this.id)
        },
        hierarchyIds() {
            if (!this.folderList.length) return []

            let items = this.questionHierarchyQuery().whereIdIn(this.folderList).with('parent.parent.parent.parent.parent.parent.parent.parent').get()
            let ids = this.folderList
            for(let i in items) {
                let parentIds = this.getParents(items[i])
                for (let x in parentIds) {
                    ids.push(parentIds[x])
                }
            }
            return uniq(ids)
        },
        hierarchyIdsMap() {
            let allowedIds = {}
            for (let i in this.hierarchyIds) {
                allowedIds[this.hierarchyIds[i]] = 1
            }
            return allowedIds
        },
        questionHierarchy() {
            return this.questionHierarchyQuery().whereIdIn(this.hierarchyIds).where('parentId', item => item == null)
            .with('children.children.children.children.children.children.children.children.children.children')
            .get()
        },
        isKnowledgeLoading() {
            return this.isLoaderActive('knowledges.fetchByPositionId')
        },
        isPositionsLoading() {
            return this.isLoaderActive('positions.fetchItems')
        },
        isLoading() {
            return this.isQuestionHierarchyLoading || this.isPositionsLoading || this.isKnowledgeLoading
        },
        isQuestionHierarchyLoading() {
            return this.isLoaderActive('questionHierarchy.fetchItems')
        },
        isTreeLoading() {
            return this.isQuestionHierarchyLoading || this.isKnowledgeLoading || this.treeIsBuilding
        },
        formPositionsIds(){
            return map(this.form.positions, 'id')
        },
        knowledgeList() {
            return this.knowledgesQuery().whereIdIn(map(filter(this.cachedKnowledgevolumeIds, item => includes(this.formPositionsIds, item.positionId)), 'id')).get()
        },
        folderList() {
            return uniq(reduce(this.knowledgeList, (sum, knowledge) => {
                each(knowledge.folders, folderId => {
                    sum.push(folderId)
                })
                return sum
            },[]))
        }
    },
    mounted() {
        this.hydrate().then(this.init).then(()=>{
        })
    },
    methods: {
        ...mapActions({
            fetchPositions: 'e/positions/fetchItems',
            fetchQuestionHierarchy: 'e/questionHierarchy/fetchItems',
            fetchEducationPlan: 'e/educationPlans/fetchItem',
            fetchKnowledges: 'e/knowledges/fetchByPositionId',
            saveEducationPlans: 'e/educationPlans/save',
        }),
        onFormChange() {
            this.saveButtonIsDisabled = false
        },
        dateFormatter(date) {
            return DateTime.fromJSDate(date).toFormat('yyyy-MM-dd')
        },
        getParents(item) {
            let t = [];
            if (item.parent) {
                t = this.getParents(item.parent)
            }
            if (item.parentId) t.push(item.parentId)
            return t
        },
        getEducationPlan() {
            return new Promise((resolve, reject) => {
                if(!this.id) resolve()
                else if(!this.educationPlan) this.fetchEducationPlan(this.id).then(resolve).catch(reject)
                else resolve(this.educationPlan)
            })
        },
        getKnowledges() {
            let promises = map(
                filter(this.form.positions, position => !includes(this.cachedKnowledgevolumePositionIds, position.id)),
                position => this.fetchKnowledges(position.id)
            )

            return Promise.all(promises).then(res => {
                let results = this.cachedKnowledgevolumePositionIds
                let cachedKnowledgevolumeIds = this.cachedKnowledgevolumeIds
                each(res, item => {
                    each(item.data, knowlege => {
                        results.push(knowlege.positionId)
                        cachedKnowledgevolumeIds.push({id: knowlege.id, positionId: knowlege.positionId})
                    })
                })
                this.cachedKnowledgevolumePositionIds = uniq(results)
                this.cachedKnowledgevolumeIds = uniqBy(cachedKnowledgevolumeIds, 'id')

                return res
            })
        },
        getPositions() {
            return new Promise((resolve, reject) => {
                if(!this.isPositionsCached) this.fetchPositions().then(resolve).catch(reject)
                else resolve(this.positions)
            }).then(res => {
                this.isPositionsCached = true
                return res
            })
        },
        getQuestionHierarchy() {
            return new Promise((resolve, reject) => {
                if(this.questionHierarchyQuery().count() === 0) this.fetchQuestionHierarchy().then(resolve).catch(reject)
                else resolve(this.questionHierarchyQuery().get())
            })
        },
        treeMounted() {
            this.treeIsBuilding = false
        },
        init() {
            this.folders = []
            this.form.organizationId = this.currentOrganizationId

            if(this.educationPlan) {
                this.form.id = this.educationPlan.id
                this.form.title = this.educationPlan.title
                this.form.description = this.educationPlan.description
                this.form.timeLimit = this.educationPlan.timeLimit
                this.form.questionCount = this.educationPlan.questionCount
                let positionIds = map(this.educationPlan.positions, 'id')
                this.selectedPosition = filter(this.positions, item => includes(positionIds, item.id))

                if (this.educationPlan.startDate) this.startDate = new Date(this.educationPlan.startDate)
                if (this.educationPlan.endDate) this.endDate = new Date(this.educationPlan.endDate)
            }
        },
        hydrate() {
            return Promise.allSettled([
                this.getPositions(),
                this.getQuestionHierarchy(),
                this.getEducationPlan(),
            ])
        },
        checked(val) {
            if (!this.treeIsBuilding) {
                this.checkedIds[val.id] = val.id
                this.saveButtonIsDisabled = false
            }
        },
        unchecked(val) {
            if (!this.treeIsBuilding) {
                delete this.checkedIds[val.id]
                this.saveButtonIsDisabled = false
            }
        },
        buildTree() {
            this.treeIsBuilding = true
            this.folders = []
            this.$nextTick(()=>{
                setTimeout(()=>{
                    this.folders = this.rebuildItems(this.questionHierarchy)
                }, 100)
            })

        },
        rebuildItems(items, parents = [], forceChecked = false) {
            const checked = this.getCheckedIdsMapByKnowledge()
            let result = [];

            for(let i in items) {
                if (!this.hierarchyIdsMap[items[i].id] && !forceChecked) {
                    continue;
                }
                let _parents = clone(parents)
                result[i] = {
                    id: items[i].id,
                    text: items[i].text,
                    children: [],
                    state: {checked: forceChecked},
                    data: {count: items[i].children.length ? 0 : items[i].childrenCount, childrenCount: items[i].childrenCount},
                }

                if (checked[items[i].id]) {
                    result[i].state.checked = true
                    this.checkedIds[items[i].id] = items[i].id
                }

                if (items[i].children.length) {
                    _parents.push(result[i])
                    result[i].children = this.rebuildItems(items[i].children, _parents, result[i].state.checked)
                } else {
                    for (let z in _parents) {
                        _parents[z].data.count += result[i].data.childrenCount;
                    }
                }
            }
            return result
        },
        getCheckedIdsMapByKnowledge() {
            if(!this.educationPlan) {
                return {}
            }
            let tmp = {}
            for(let i in this.educationPlan.folders) {
                tmp[this.educationPlan.folders[i]] = this.educationPlan.folders[i]
            }
            return tmp
        },
        getKnowledgesAndBuildTree() {
            return this.getKnowledges().then((res) => {
                this.buildTree()
                return res
            })
        },
        save() {
            let folders = this.questionHierarchyQuery().with('children').findIn(values(this.checkedIds))
            let checkedIds = []
            for (let i in folders) {
                if(folders[i].children.length === 0) checkedIds.push(folders[i].id)
            }
            this.form.folders = checkedIds

            if (this.anyErrors()) {
                return
            }
            this.saving = true
            return this.saveEducationPlans(this.form).then(()=>{
                this.$router.push({name: 'education-plan'})
            }).finally(()=>{
                this.saving = false
            })
        }
    },
    watch: {
        startDate: {
            immediate: true,
            handler(value) {
                this.form.startDate = DateTime.fromJSDate(value).toFormat('yyyy-MM-dd')
            }
        },
        endDate: {
            immediate: true,
            handler(value) {
                this.form.endDate = DateTime.fromJSDate(value).toFormat('yyyy-MM-dd')
            }
        },
        selectedPosition(value) {
            this.form.positions = map(this.selectedPosition, item => {
                return {id: item.id}
            })
        },
        currentOrganizationId: {
            handler(value) {
                this.form.organizationId = value
                this.cachedKnowledgevolumeIds = []
                this.cachedKnowledgevolumePositionIds = []

                if (this.id && value) {
                    this.$router.push({name: 'education-plan'})
                }else if (value) {
                    this.getKnowledgesAndBuildTree()
                }
            }
        },
        'form.positions': {
            handler(value) {
                this.getKnowledgesAndBuildTree()
            }
        },
        saving: {
            immediate: true,
            handler(value) {
                this.$emit('saving', value)
            }
        },
        saveButtonIsDisabled: {
            immediate: true,
            handler(value) {
                this.$emit('disable', value)
            }
        }
    }
}
</script>